import React from "react";
import Counter from "./Counter";
import Rating from "../../Util/Rating/Rating";
import { CounterStatsContainer, CounterBlock } from "./CountersBlock.elements";

const CounterStats = (props) => {
    return (
        <CounterStatsContainer>
            <CounterBlock>
                <Rating rating={props.avgRating} title="Rating" />
                <Counter count={props.clips} title="Total clips" />
                <Counter count={props.uploads} title="Total uploads" />
            </CounterBlock>
        </CounterStatsContainer>
    );
};

export default CounterStats;
